import React from 'react';
import { Button, Typography } from '@material-tailwind/react';

function Jumbroton() {
  return (
    <div>
        <div className='px-7 md:px-11 py-5 mb-16 grid grid-cols-1 md:grid-cols-2 '>
            <div className='row-start-2 md:row-span-full grid content-end text-center md:text-left '>
                {/* <h1 className='font-bold mt-4 text-3xl md:text-4xl lg:text-5xl py-2'>Get Real Job As You Want</h1> */}
                <Typography variant='h1'>Get Real Job As You Want Work</Typography>
                <Typography variant='lead' className='mb-8'>Find job easier and complete near your location</Typography>
                <Button className='m-auto md:m-0  w-1/2 md:w-2/6' size='sm'>Get Job Now</Button>
            </div>
            <div className='pb-6 md:p-0 row-start-1 flex justify-center items-center'>
                <img className='w-3/4' src='Hero.png' alt='Hero karana'/>
            </div>
        </div>
    </div>

  )
}

export default Jumbroton